/* eslint-disable */
import React from 'react';
import { TableCell, Typography } from '@mui/material';

/**
 * TableCellItem
 *
 * Renders a single <TableCell>.
 * If the column has a `render` function, it calls render(row, rowIndex).
 * Otherwise it displays row[column.id] as plain text.
 *
 * Props:
 *  column  {object}  — column definition { id, align, width, render, sx }
 *  row     {object}  — data row object
 *  index   {number}  — row index (passed to render fn)
 */
const TableCellItem = ({ column, row, index }) => {
  const value = row[column.id];

  return (
    <TableCell
      align={column.align || 'left'}
      sx={{
        py: '8px',
        px: '16px',
        fontSize: '13px',
        color: '#000000',
        fontWeight: 700,
        borderBottom: '1px solid #F0F2F5',
        width: column.width,
        whiteSpace: column.noWrap ? 'nowrap' : 'normal',
        ...column.cellSx,
      }}
    >
      {column.render ? (
        column.render(row, index)
      ) : (
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: 700,
            color: '#000000',
          }}
        >
          {value ?? '—'}
        </Typography>
      )}
    </TableCell>
  );
};

export default TableCellItem;
